import { TERMINAL_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: TERMINAL_MNG,
  params: null,
  view: {
    title: '创建终端数据',
    labelPosition: 'right',
    width: '700px',
    content: [
      {
        $id: 'manufacturer',
        $type: 'input',
        label: '品牌名称',
        $el: {
          placeholder: '请输入品牌名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '品牌名称'
          }
        ]
      },
      {
        $id: 'model',
        $type: 'input',
        label: '终端型号',
        $el: {
          placeholder: '请输入终端型号',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '终端型号'
          }
        ]
      },
      {
        $id: 'type',
        $type: 'select',
        label: '终端类型',
        $el: {
          placeholder: '请输入终端类型',
          suffixIcon: 'el-icon-edit',
          filterable: true
        },
        $options: [
          {
            label: 'VDI终端',
            value: 'VDI'
          },
          {
            label: 'IDV终端',
            value: 'IDV'
          },
          {
            label: 'TCI终端',
            value: 'TCI'
          },
          {
            label: '安卓软客户端',
            value: 'ANDROID'
          },
          {
            label: 'IOS软客户端',
            value: 'IOS'
          },
          {
            label: 'MAC OS软客户端',
            value: 'MAC'
          },
          {
            label: '利旧PC',
            value: 'PC'
          },
          {
            label: 'Windows PC软客户端',
            value: 'WINDOWS'
          }
        ],
        rules: [
          {
            notEmpty: '终端类型'
          }
        ]
      },
      {
        $id: 'cpu',
        $type: 'input',
        label: 'cpu信息',
        $el: {
          placeholder: '请输入cpu信息',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: 'cpu信息'
          }
        ]
      },
      {
        $id: 'cpuCore',
        $type: 'input-number',
        label: 'CPU核数',
        $el: {
          placeholder: '请输入CPU核数',
          suffixIcon: 'el-icon-edit',
          min: 1
        },
        rules: [
          {
            notEmpty: 'CPU核数'
          }
        ]
      },
      {
        $id: 'cpuFrequency',
        $type: 'input',
        label: 'CPU频率数',
        $el: {
          placeholder: '请输入CPU频率',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: 'CPU频率数'
          }
        ]
      },
      {
        $id: 'memory',
        $type: 'input-number',
        label: '内存信息',
        $el: {
          placeholder: '请输入内存信息',
          suffixIcon: 'el-icon-edit',
          min: 1
        },
        rules: [
          {
            notEmpty: '内存信息'
          }
        ]
      },
      {
        $id: 'diskSize',
        $type: 'input-number',
        label: '硬盘大小',
        $el: {
          placeholder: '请输入硬盘大小',
          suffixIcon: 'el-icon-edit',
          min: 1
        },
        rules: [
          {
            notEmpty: '硬盘大小'
          }
        ]
      },
      {
        $id: 'diskCount',
        $type: 'input-number',
        label: '硬盘数量',
        $el: {
          placeholder: '请输入硬盘数量',
          suffixIcon: 'el-icon-edit',
          min: 1
        },
        rules: [
          {
            notEmpty: '硬盘数量'
          }
        ]
      },
      {
        $id: 'gpuModel',
        $type: 'input',
        label: '显卡型号',
        $el: {
          placeholder: '请输入显卡型号',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        },
        rules: [
          {
            notEmpty: '显卡型号'
          }
        ]
      },
      {
        $id: 'remarks',
        $type: 'input',
        label: '使用说明',
        $el: {
          placeholder: '请输入使用说明或使用限制',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      }
    ]
  }
}
